function getNextAndPrevDate(date, dates) {
  if (!date || !Array.isArray(dates) || dates.length === 0) {
    return {
      next: undefined,
      prev: undefined,
    };
  }

  const index = dates.findIndex(e => e === new Date(date).toDateString());

  if (index === -1) {
    return {
      next: undefined,
      prev: undefined,
    };
  }

  return {
    prev: index + 1 < dates.length ? dates[index + 1] : undefined,
    next: index - 1 >= 0 ? dates[index - 1] : undefined,
  };
}

export {
  getNextAndPrevDate,
};
